export function formatTime(val) {
  if (!val) return '-'
  const d = new Date(val)
  if (isNaN(d.getTime())) return '-'
  const pad = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
}

export function formatNumber(value) {
  if (value == null || isNaN(Number(value))) return '-'
  const n = Number(value)
  if (n >= 100000000) return (n / 100000000).toFixed(2) + '亿'
  if (n >= 10000) return (n / 10000).toFixed(2) + '万'
  return n % 1 === 0 ? n.toString() : n.toFixed(2)
}

// 模型类型元信息：label 展示名 / short 徽标字 / badgeShort 徽标样式类 / tagType el-tag 类型 / unit 单价单位 / unitShort 单价单位短
export const MODEL_TYPE_META = {
  TEXT:     { label: '文本', short: '文', badgeShort: 'txt', tagType: 'info',     unit: '/ 1K tokens', unitShort: '/ 1K', fields: ['input', 'output', 'cache'] },
  IMAGE:    { label: '图片', short: '图', badgeShort: 'img', tagType: 'warning',  unit: '/ 张',        unitShort: '/ 张', fields: ['output'] },
  EMBEDDING:{ label: '向量', short: '向', badgeShort: 'emb', tagType: 'success',  unit: '/ 1K tokens', unitShort: '/ 1K', fields: ['input'] },
  RERANK:   { label: '重排', short: '排', badgeShort: 'rrm', tagType: 'danger',   unit: '/ 1K tokens', unitShort: '/ 1K', fields: ['input'] },
  ASR:      { label: '语音识别', short: '语', badgeShort: 'spk', tagType: 'warning',  unit: '/ 千秒',      unitShort: '/ 千秒', fields: ['input'] }
}

export function modelTypeInfo(type) {
  return MODEL_TYPE_META[type] || MODEL_TYPE_META.TEXT
}

export function modelTypeLabel(type) {
  return modelTypeInfo(type).label
}